import React, { useState, useEffect } from 'react';
import { 
  StickyNote2 
} from '@mui/icons-material';

import { Button } from '@mui/material';

interface Props {
  disabled?: boolean;
  label?: string;
  onClick: () => void;
}

export default function NotesButton({ 
  disabled = false,
  label = "",
  onClick 
}: Props) {
  const [is_disabled, setDisabled] = useState(disabled);

  useEffect(() => {
    setDisabled(disabled);
  }, [disabled]);

  const className =`${is_disabled ? " disabled" : ""}`;

  if (label === "") {
    return (
      <StickyNote2 className="clickable"
        onClick={onClick}
      />
    );
  } else {
    return (
      <Button
        className={className}
        disabled={disabled} 
        onClick={onClick}
        variant="contained" color="primary">
        <StickyNote2/>&nbsp;{ label }
      </Button>
    );
  }
}
